<script setup lang="ts">
import { UISpin, UITooltip, UITag } from "@gohighlevel/ghl-ui";
import { InfoCircleIcon } from "@gohighlevel/ghl-icons/24/outline";
import { useI18n } from "vue-i18n";

const { t } = useI18n();
defineProps({
  header: {
    type: String,
    default: "",
  },
  list: {
    type: Array<any>,
    default: [],
  },
  showLoader: {
    type: Boolean,
    default: false,
  },
  tooltip: {
    type: String,
    default: "",
  },
  showNewTag: {
    type: Boolean,
    default: false,
  },
});
</script>
<template>
  <div class="card-main">
    <div
      class="header flex items-center justify-between px-3 py-2 text-sm font-medium text-gray-700"
    >
      <div>
        {{ header }}
        <UITooltip v-if="tooltip" :style="{ maxWidth: '300px' }" trigger="hover" placement="top">
          <template #trigger>
            <InfoCircleIcon class="ml-1 h-4 w-4 text-gray-400"></InfoCircleIcon>
          </template>
          {{ tooltip }}
        </UITooltip>
        <UITag v-if="showNewTag" type="warning" :round="false" size="small">
          {{ t("common.new") }}
        </UITag>
      </div>
      <UISpin v-if="showLoader" size="small" />
    </div>
    <div class="hr"></div>
    <div class="p-3">
      <slot></slot>
    </div>
  </div>
</template>

<style>
.card-main {
  background-color: #fff;
  border-radius: 4px;
}
.card-main .header {
  border-bottom: 2px solid #e7f3fe;
}
</style>
